import Image from 'next/image';

interface Partner {
  src: string;
  alt: string;
  width: number;
  height: number;
  link: string;
}

export default function MediaPartnersLogoSection() {
  const MediaPartnersLogo: Partner[] = [
    /*
    {
      alt: "Cryptonewsz",
      src: "/images/cryptonewsz.webp",
      width: 148,
      height: 58,
      link: "https://www.cryptonewsz.com/",
    },
    {
      alt: "NameCoinNews",
      src: "/images/namecoinnews.webp",
      width: 148,
      height: 58,
      link: "https://www.namecoinnews.com/",
    },
    {
      alt: "timesofai",
      src: "/images/timesofai.webp",
      width: 148,
      height: 58,
      link: "https://www.timesofai.com/",
    },
    {
      alt: "Coinnewsspan",
      src: "/images/coinnewsspan-new.svg",
      width: 148,
      height: 58,
      link: "https://www.coinnewsspan.com/",
    },
    {
      alt: "Cryptomoonpress",
      src: "/images/cryptomoonpress-logo.webp",
      width: 148,
      height: 58,
      link: "https://cryptomoonpress.com/",
    },
    {
      alt: "CapitalBayLogo",
      src: "/images/capitalbay-logo.webp",
      width: 148,
      height: 58,
      link: "https://www.capitalbay.news/",
    },
    {
      src: '/images/all-conference-alert.webp',
      alt: 'all-conference-alert',
      width: 144,
      height: 60,
      link: 'https://www.allconferencealert.com/',
    },
    {
      src: '/images/times-of-blockchain.svg',
      alt: 'Times of Blockchain',
      width: 148,
      height: 58,
      link: 'https://www.timesofblockchain.com/',
    },
    {
      src: '/images/al-huda-logo.webp',
      alt: 'AlHuda-Logo',
      width: 148,
      height: 58,
      link: 'https://www.alhudacibe.com/',
    },
    {
      src: '/images/coin-gabbar.webp',
      alt: 'Coin-Gabbar',
      width: 148,
      height: 58,
      link: 'https://www.coingabbar.com/',
    },
    {
      src: '/images/cryptoJist-black.webp',
      alt: 'cryptojist',
      width: 148,
      height: 58,
      link: 'https://cryptojist.com/',
    },
    {
      src: '/images/gtm-lab-logo.webp',
      alt: 'GTM-Labs-Logo-without-BG',
      width: 148,
      height: 58,
      link: 'https://gtmlabs.xyz/',
    },
    {
      src: '/images/the-coin-republic.webp',
      alt: 'The-coin-Republic',
      width: 148,
      height: 58,
      link: 'https://www.thecoinrepublic.com/',
    },
    {
      src: '/images/voice-of-crypto.webp',
      alt: 'voice-of-crypto',
      width: 148,
      height: 58,
      link: 'https://voiceofcrypto.online/',
    },
    {
      src: '/images/theblockopedia-new.webp',
      alt: 'theblockopedia',
      width: 148,
      height: 58,
      link: 'https://theblockopedia.com/',
    },
    {
      src: '/images/cio-review.webp',
      alt: 'CIO-REVIEW',
      width: 148,
      height: 58,
      link: 'https://www.cioreview.com/',
    },
    {
      src: '/images/edarabia-logo.webp',
      alt: 'edarabia',
      width: 148,
      height: 58,
      link: 'https://www.edarabia.com/',
    },
    {
      src: '/images/ai-time-journal.webp',
      alt: 'aitimejournal',
      width: 148,
      height: 58,
      link: 'https://www.aitimejournal.com/',
    },
    {
      src: '/images/cryptoolitan-logo.webp',
      alt: 'cryptoolitan-logo',
      width: 148,
      height: 58,
      link: 'https://www.cryptopolitan.com/',
    },
    {
      src: '/images/cryptoken-media-logo.webp',
      alt: 'cryptoken-media-logo',
      width: 148,
      height: 58,
      link: 'https://cryptoken.media',
    },
    {
      src: '/images/cryptobrowser.webp',
      alt: 'cryptobrowser',
      width: 148,
      height: 58,
      link: 'https://cryptobrowser.io/',
    },
    {
      src: '/images/Web3Wire-Logo.webp',
      alt: 'Web3Wire-Logo',
      width: 148,
      height: 58,
      link: 'https://web3wire.org',
    },
    {
      src: '/images/embassyofbitcoin.webp',
      alt: 'embassyofbitcoin',
      width: 148,
      height: 58,
      link: 'https://www.embassyofbitcoin.com/',
    },
    {
      src: '/images/international-business-magazine.webp',
      alt: 'international-business-magazine',
      width: 148,
      height: 58,
      link: 'https://intlbm.com/',
    },
    {
      src: '/images/conlytix.webp',
      alt: 'conlytix',
      width: 148,
      height: 58,
      link: 'https://coinlytx.com/',
    },
    {
      src: '/images/3versetv.webp',
      alt: '3versetv',
      width: 148,
      height: 58,
      link: 'https://www.3versetv.com/',
    },
    {
      src: '/images/zexprwire-logo.webp',
      alt: 'zexprwire-logo',
      width: 148,
      height: 58,
      link: 'https://zexprwire.com/',
    },
    {
      src: '/images/coingape.webp',
      alt: 'coingape',
      width: 148,
      height: 58,
      link: 'https://coingape.com/',
    },
    {
      src: '/images/coinpedia.webp',
      alt: 'coinpedia',
      width: 148,
      height: 58,
      link: 'https://coinpedia.org/',
    },
    
    {
      src: '/images/startupnews.webp',
      alt: 'StartupNews-logo',
      width: 148,
      height: 58,
      link: 'https://startupnews.fyi/',
    },
     {
      src: '/images/financialservicesreview.webp',
      alt: 'financialservicesreview',
      width: 148,
      height: 58,
      link: 'https://www.financialservicesreview.com/',
    },
     {
      src: '/images/logo-black-messtori-blockchain.webp',
      alt: 'logo-black-messtori-blockchain',
      width: 148,
      height: 58,
      link: 'https://messtori.com/blockchain/',
    },
    {
      src: '/images/cmo-intern.webp',
      alt: 'CMO-Intern',
      width: 148,
      height: 58,
      link: 'https://www.cmointern.com/',
    },
    {
      src: '/images/fintech24h.webp',
      alt: 'fintech24h',
      width: 148,
      height: 58,
      link: 'https://fintech24h.com/',
    },
    {
      src: '/images/conlytix-logo.webp',
      alt: 'conlytix-logo',
      width: 148,
      height: 58,
      link: 'https://coinlytx.com/',
    },
    {
      src: '/images/golden-sea.webp',
      alt: 'golden-sea',
      width: 148,
      height: 58,
      link: 'https://goldenseastudios.com/',
    },
    {
      src: '/images/tmp-logo.webp',
      alt: 'TMP-tmp-logo',
      width: 148,
      height: 58,
      link: 'https://themarketperiodical.com/',
    },

    {
      src: '/images/cryptonewss.webp',
      alt: 'CryptosNewss',
      width: 148,
      height: 58,
      link: 'https://cryptosnewss.com/',
    },
    {
      src: '/images/cryptonews.webp',
      alt: 'CryptoNews',
      width: 148,
      height: 58,
      link: 'https://cryptonews.com/',
    },

    {
      src: '/images/affmaven-logo.webp',
      alt: 'AFFMaven',
      width: 148,
      height: 58,
      link: 'https://affmaven.com/',
    },
    {
      src: '/images/bitcoinworld.webp',
      alt: 'Bitcoin-World',
      width: 148,
      height: 58,
      link: 'https://bitcoinworld.co.in/',
    },
    {
      src: '/images/indewswire-logo.webp',
      alt: 'indewswire-logo',
      width: 148,
      height: 58,
      link: 'https://indnewswire.com/',
    },
    {
      src: '/images/droomblack.webp',
      alt: 'DroomDroom-Black',
      width: 148,
      height: 58,
      link: 'https://droomdroom.com/',
    },

    {
      src: '/images/web3africa.webp',
      alt: 'web3africa',
      width: 148,
      height: 58,
      link: 'https://web3africa.tech/',
    },
    {
      src: '/images/dubai-global-news.webp',
      alt: 'dubai-global-news',
      width: 148,
      height: 58,
      link: 'https://www.dubaiglobalnews.com/',
    },
    {
      src: '/images/blockchainreporter.webp',
      alt: 'blockchainreporter',
      width: 148,
      height: 58,
      link: 'https://blockchainreporter.net/',
    },
    {
      src: '/images/games-3s-logo.webp',
      alt: 'games-3s-logo',
      width: 148,
      height: 58,
      link: 'https://www.games.gg/',
    },
    
    {
      src: '/images/invest24-logo.webp', 
      alt: 'invest24',
      width: 148,
      height: 58,
      link: 'https://www.invest24.uz/',
    },

    {
      src: '/images/blockchain-texno.webp', 
      alt: 'blockchain-texno',
      width: 148,
      height: 58,
      link: 'https://www.blockchaintexno.uz/',
    },

    {
      src: '/images/tredu-logopr.svg', 
      alt: 'tredu',
      width: 148,
      height: 58,
      link: 'https://www.tredu.com/',
    },
*/

    {
      src: '/images/etherpr.webp',
      alt: 'etherpr',
      width: 148,
      height: 58,
      link: 'https://etherpr.com/',
    },
    {
      src: '/images/coinraftar-black.webp',
      alt: 'coinraftar',
      width: 148,
      height: 58,
      link: 'https://coinraftar.com/',
    },
    {
      src: '/images/zexprwire.webp',
      alt: 'zexprwire',
      width: 148,
      height: 58,
      link: 'https://zexprwire.com/',
    },
    {
      src: '/images/keywiredifference.webp',
      alt: 'keydifference-wire',
      width: 148,
      height: 58,
      link: 'https://keydifference.com/wire/',
    },
    {
      src: '/images/edarabia-new.webp',
      alt: 'edarabia',
      width: 148,
      height: 58,
      link: 'https://www.edarabia.com/',
    },
    {
      src: '/images/btcwire.webp',
      alt: 'btcwire',
      width: 148,
      height: 58,
      link: 'https://btcwire.io/',
    },
    {
      src: '/images/news247.webp',
      alt: 'menews247',
      width: 148,
      height: 58,
      link: 'https://menews247.com/',
    },
    {
      src: '/images/logo-lance.webp',
      alt: 'Lance',
      width: 148,
      height: 58,
      link: 'https://www.lance.com.br/',
    },
    {
      src: '/images/findmoreafrica.webp',
      alt: 'Find More Africa',
      width: 148,
      height: 58,
      link: 'https://findmoreafrica.com/',
    },
    {
      src: '/images/timeslogo.webp',
      alt: 'The Times of UAE',
      width: 148,
      height: 58,
      link: 'https://thetimesofuae.com/',
    },
    {
      src: '/images/gazet.webp',
      alt: 'Gazet International',
      width: 148,
      height: 58,
      link: 'https://gazetinternational.com/',
    },
    {
      src: '/images/bfmtimes-without-bg.webp',
      alt: 'BFM Times',
      width: 148,
      height: 58,
      link: 'https://bfmtimes.com/',
    },
    {
      src: '/images/coinrab.webp',
      alt: 'CoinRab',
      width: 148,
      height: 58,
      link: 'https://coinrab.com/',
    },
    {
      src: '/images/smartmoneymatch.webp',
      alt: 'Smart Money Match',
      width: 148,
      height: 58,
      link: 'https://www.smartmoneymatch.com/',
    },
    {
      src: '/images/transportstake-without-bg.webp',
      alt: 'TransportStake',
      width: 148,
      height: 58,
      link: 'https://www.transportstake.com/',
    },
    {
      src: '/images/publicitymarketplace-without-bg.webp',
      alt: 'Publicity Marketplace',
      width: 148,
      height: 58,
      link: 'https://www.publicitymarketplace.com/',
    },
    {
      src: '/images/functionalsourcing.webp',
      alt: 'Functional Sourcing',
      width: 148,
      height: 58,
      link: 'https://www.functionalsourcing.com/',
    },
    {
      src: '/images/education-stake-logo.webp',
      alt: 'EducationStake',
      width: 148,
      height: 58,
      link: 'https://www.educationstake.com/',
    },
    {
      src: '/images/match-sdg-logo.webp',
      alt: 'MatchSDG',
      width: 148,
      height: 58,
      link: 'https://www.matchsdg.com/',
    },
    {
      src: '/images/huidu.webp',
      alt: 'huidu',
      width: 148,
      height: 58,
      link: 'https://www.huidu.cn/en',
    },
    {
      src: '/images/theglobalhues.webp',
      alt: 'theglobalhues',
      width: 148,
      height: 58,
      link: 'https://theglobalhues.com/',
    },
    {
      src: '/images/nendigital.webp',
      alt: 'nendigital',
      width: 148,
      height: 58,
      link: 'https://www.nendigital.com/',
    },
    {
      src: '/images/exchange1-logo.webp',
      alt: 'exchange1-logo',
      width: 148,
      height: 58,
      link: 'https://www.exchange1.com/',
    },
    {
      src: '/images/the-gignomist.webp',
      alt: 'gignomist',
      width: 148,
      height: 58,
      link: 'https://gignomist.com/',
    },
];


  return (
    <section data-component-id="src/app/MediaPartnersLogoSection.tsx:545:4" data-component-path="src/app/MediaPartnersLogoSection.tsx" data-component-line="545" data-component-end-line="575" data-component-file="MediaPartnersLogoSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22mediapartners%22%2C%22className%22%3A%22w-full%20max-w-%5B1340px%5D%20mx-auto%20px-4%20py-16%20bg-white%20mt-%5B24px%5D%20sm%3Amt-%5B36px%5D%20md%3Amt-%5B0px%5D%22%7D"
      id="mediapartners"
      className="w-full max-w-[1340px] mx-auto px-4 py-16 bg-white mt-[24px] sm:mt-[36px] md:mt-[0px]"
    >
      {/* Section Title */}
      <h2 data-component-id="src/app/MediaPartnersLogoSection.tsx:550:6" data-component-path="src/app/MediaPartnersLogoSection.tsx" data-component-line="550" data-component-end-line="552" data-component-file="MediaPartnersLogoSection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-%5B32px%5D%20sm%3Atext-%5B28px%5D%20md%3Atext-%5B48px%5D%20font-instrument%20font-medium%20leading-%5B35px%5D%20sm%3Aleading-%5B38px%5D%20md%3Aleading-%5B42px%5D%20text-center%20text-%5B%23000000%5D%20mb-5%22%2C%22textContent%22%3A%22Media%20Partners%22%7D" className="text-[32px] sm:text-[28px] md:text-[48px] font-instrument font-medium leading-[35px] sm:leading-[38px] md:leading-[42px] text-center text-[#000000] mb-5">
        Media Partners
      </h2>

      {/* Partners Grid */}
      <div data-component-id="src/app/MediaPartnersLogoSection.tsx:555:6" data-component-path="src/app/MediaPartnersLogoSection.tsx" data-component-line="555" data-component-end-line="574" data-component-file="MediaPartnersLogoSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20sm%3Agrid-cols-3%20md%3Agrid-cols-6%20gap-4%20sm%3Agap-6%20md%3Agap-8%22%7D" className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-4 sm:gap-6 md:gap-8">
        {MediaPartnersLogo.map((partner, index) => (
          <a data-component-id="src/app/MediaPartnersLogoSection.tsx:557:10" data-component-path="src/app/MediaPartnersLogoSection.tsx" data-component-line="557" data-component-end-line="572" data-component-file="MediaPartnersLogoSection.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22className%22%3A%22flex%20justify-center%20items-center%20bg-%5B%23f3f4f6%5D%20rounded-%5B6px%5D%20min-h-%5B100px%5D%20p-4%20sm%3Ap-2%22%7D"
            key={index}
            href={partner.link}
            target="_blank"
            rel={index === 0 ? "noopener noreferrer" : "noopener noreferrer nofollow"}
            className="flex justify-center items-center bg-[#f3f4f6] rounded-[6px] min-h-[100px] p-4 sm:p-2"
          >
            <Image data-component-id="src/app/MediaPartnersLogoSection.tsx:564:12" data-component-path="src/app/MediaPartnersLogoSection.tsx" data-component-line="564" data-component-end-line="571" data-component-file="MediaPartnersLogoSection.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22object-contain%20max-h-%5B80px%5D%22%7D"
              src={partner.src}
              alt={partner.alt}
              width={partner.width}
              height={partner.height}
              className="object-contain max-h-[80px]"
              unoptimized
            />
          </a>
        ))}
      </div>
    </section>
  );
}
